<template>
  <div class="row listing-card-item">
    <div
      v-if="imageSrc.length > 0"
      class="col-lg-3"
    >
      <template v-if="routerLink">
        <router-link :to="routerLink">
          <img
            class="item-image"
            :src="imageSrc"
          >
        </router-link>
      </template>
      <template v-else>
        <a :href="link">
          <img
            class="item-image"
            :src="imageSrc"
          >
        </a>
      </template>
    </div>
    <div class="col-lg-6">
      <div
        class="title"
        v-text="title"
      />
      <!-- <LoyaltyTiers
        v-if="loyaltyTier"
        :loyalty-tier="loyaltyTier"
      /> -->
      <slot name="description">
        <div
          class="description"
          :class="{ 'showDescription': showDescription }"
          v-text="description"
        />
      </slot>
    </div>
    <div
      class="col-lg-3 buttons"
    >
      <slot name="button" />
      <template v-if="routerLink">
        <Button
          v-if="buttonText.length > 0"
          :label="buttonText"
        >
          <router-link
            :to="routerLink"
            v-text="buttonText"
          />
        </Button>
      </template>
      <template v-else>
        <Button
          v-if="buttonText.length > 0"
          :label="buttonText"
          :link="link"
        />
      </template>
    </div>
  </div>
</template>

<script>
import Button from './Button.vue'
// import LoyaltyTiers from './reusable/loyalty-tiers.vue'

export default {
  name: 'ListingCardItem',
  components: {
    Button
  },
  props: {
    buttonText: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    imageSrc: {
      type: String,
      required: true
    },
    link: {
      type: String,
      default: ''
    },
    loyaltyTier: {
      type: String,
      default: ''
    },
    routerLink: {
      type: Object,
      default: () => {}
    },
    showDescription: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang='scss' scoped>
.title {
  @include font-weight-bold;
  text-transform: uppercase;
  font-size: 13px;
  line-height: 16px;
  margin-bottom: 4px;
}

.item-image {
  border: 1px solid $grey-light;
  min-height: 100px;
  width: 100%;
}

@include media-breakpoint-down(md) {
  .row > div {
    text-align: center;
  }
}

@include media-breakpoint-down(sm) {
  .description {
    display: none;
  }

  .showDescription {
    display: block;
  }

  .buttons {
    display: none;
  }
}
</style>
